
export default class MemberOrderResponseModel {
    public orderId: number = 0;
    public productName: string = '';
    public quantity: number = 0;
    public price: number = 0;
    public extendedPrice: number = 0;
    public discount: number = 0;
    public subTotal: number = 0;
    public tax: number = 0;
    public total: number = 0;
    public referenceNumber: string = '';
    public createdDateTimeUtc?: Date;
    public createdBy: string = '';
}
